
    /**
    * 前台用户忘记密码
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid13220 {
  /**
   * 手机号
   */
  mobile: string | number;
  /**
   * 密码
   */
  password: string | number;
}
  export class IResid13220 {
  code?: number;
  data?: string;
  message?: string;
  success?: boolean;
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid13220, IResid13220['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/account/forgetPwd',
        params: data
      }) 
  export default http